/**
 * Row data: the calendar vocabularies of 1.0b deliverable 3. The values are 1.K-1's (its
 * deliverables 1, 2, 12 and 14), copied in the order given there; the calendar engine imports
 * these constants and declares no list of its own. Pure data (excluded from mutation testing).
 */
import { TICK_STATUSES } from '../domain/rows-enums.js';
/**
 * The errors `compile` reports: `invalid_shape` for every issue the `CalendarDefinition` schema
 * raises (at its path), then the six cross-field rules no schema field can state.
 */
export const CALENDAR_ERROR_CODES = [
    'invalid_shape',
    'no_regular_month',
    'duplicate_ordinal',
    'bad_month_length',
    'bad_season_start',
    'bad_era',
    'calendar_too_large',
];
/** The warnings `compile` reports. */
export const CALENDAR_WARNING_CODES = [
    'leap_rule_dormant',
    'day_offset_ignored',
    'seasons_out_of_order',
    'starting_weekday_inconsistent',
    'ambiguous_name',
    'eras_leave_gap',
    'eras_share_start',
];
/** P0-13's six import warnings, as `importFoundry` writes them. */
export const FOUNDRY_IMPORT_WARNING_CODES = [
    'leap_rule_dormant',
    'days_per_year_mismatch',
    'season_bounds_touch',
    'season_gap',
    'season_overlap',
    'invalid_calendar',
];
/** Why a When input could not be read (1.K-1 deliverable 12). */
export const PARSE_ERROR_CODES = [
    'empty',
    'unknown_name',
    'ambiguous_name',
    'missing_year',
    'now_unset',
    'day_out_of_range',
    'time_out_of_range',
    'week_out_of_range',
    'mixed_precision',
    'anchor_expected',
    'bad_lag',
    'unexpected_text',
    'calendar_invalid',
];
/** The kinds of a parsed When phrase. */
export const WHEN_KINDS = ['point', 'now', 'session', 'relative', 'undated', 'invalid'];
/** A When preview's status: the four `TICK_STATUSES` values, then `pending` and `undated`. */
export const WHEN_PREVIEW_STATUSES = [...TICK_STATUSES, 'pending', 'undated'];
//# sourceMappingURL=rows-calendar.js.map